module.exports = __webpack_public_path__ + "@/assets/img/01.20049ebb.svg";